module.exports = {
  CART_URL: (window.cartServiceUrl || '') + '/api/v1'
}
